import { UrlManager } from '../../assets/js/utils/UrlManager';

class MyAccountOrders {
    mainContainer;
    filterTimeInput;
    filterDropdown;
    UrlManager;

    constructor(elm) {
        this.mainContainer = elm;
        this.filterTimeInput = this.mainContainer.querySelector('#dropdownInput');
        this.filterDropdown = this.mainContainer.querySelector('[data-filter-dropdown]');
        this.urlManager = new UrlManager();

        this.init();
    }

    init() {
        //console.log(this.filterTimeInput);
        this.filterDropdown.addEventListener('dropdown:change', this._timeFilerChanged);
    }

    _timeFilerChanged = (e) => {
        e.preventDefault();
        this.urlManager.setPath(this.mainContainer.dataset.baseUrl);
        
        const activeTab = this.mainContainer.querySelector('.account-page__content-history-head-button.active');
        this.urlManager.setUrlParam('tab', activeTab.dataset.tab);
        this.urlManager.setUrlParam('filter_time', this.filterTimeInput.value);

        window.location.replace(window.location.href);
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const orders = document.querySelector('.account-page__content-history');
    if (orders) {
        new MyAccountOrders(orders);
    }
});